import styled from 'styled-components';
import { stylesIf, breakpoints, hexToRgba, breakpointsRebrand } from '../utils/styleHelpers';
import Button from '@veneer/core/dist/scripts/button';
import Accordion from '@veneer/core/dist/scripts/accordion';
import { colors, spacing } from '@clientos/ui-toolkit';

export const ReTargetContainer = styled.div`
  display:flex;
  flex-direction: column;
  height: 615px;
  width: 930px;
  border-radius: 24px;
  padding: 32px;
  flex-wrap: nowrap;
  align-items: center;
  box-sizing: border-box;
  min-height: auto
  overflow: auto;
  margin: 0 auto;
  justify-content: space-around;
  font-family: "Forma DJR UI", "HP Simplified", sans-serif;
  direction:${(props) => (props.isRTL ? 'rtl' : 'ltr')};

  &&{
    .vn-animated-height__wrapper-inner>div {
      padding:0.5rem 0;
    }
  }

  @media screen and (min-width:${breakpoints.tablet}) {
    max-width: 64rem;
    margin: 1rem auto 0;
    height: 100%;
  }

  @media screen and (min-width:500px) and (max-width:500px) and (min-height:530px ) and (max-height:530px) {
    display:flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    box-sizing: border-box;
    min-height: auto
    overflow: hidden;
    width:100%;
    margin-top: 2rem auto;
    height: 100vh;
    justify-content: space-between;
  
  }

  @media screen and (max-width: ${breakpoints.mobile}) {
   display: block;
   height: auto;
   padding: 24px;
   width: auto;
  }
`;

export const ReTargetContentContainer = styled.div`
  flex-grow: 0;
  margin: 0 0.5rem;
  ${(props) =>
    props.isIOS &&
    `
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
  `}
  @media screen and (min-width: ${breakpoints.tablet}) {
    width: 100%;
  }

  @media only screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    width: 90%;
  }
`;

export const Title = styled.h4`
  font-family: "Forma DJR UI", "HP Simplified", sans-serif;
  font-size: ${spacing.space_xl};
  font-weight: 500;
  line-height: ${spacing.space_2xl};
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  && {
    @media screen and (max-width: ${breakpoints.mobile}) {
      font-size: ${spacing.space_l};
      line-height: 28px;
      text-align: center;
    }
  }
`;

export const Body = styled.div`
  width: 100%;
  color: ${colors.inkSecondary};
  font-family: "Forma DJR UI", "HP Simplified", sans-serif;
  font-size: ${spacing.space_sm};
  font-weight: 400;
  line-height: ${spacing.space_l};
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  text-align: left;

  && {
    @media screen and (max-width: ${breakpoints.mobile}) {
      line-height: ${spacing.space_l};
      font-size: 14px;
    }

    p,
    > span > p {
      > a {
        color: ${colors.interactiveLinkBase};
        text-decoration: ${(props) => (props.isWJA ? 'none' : 'underline')};
        :hover {
          color: #006691;
        }
        :active {
          color: #004f74;
        }
      }
    }
  }
`;

export const PrinterConsentDescription = styled.div`
  color: ${colors.inkSecondary};
  padding: 0 ${spacing.space_xl};

  @media screen and (max-width: ${breakpoints.tablet}) {
    padding: 0 ${spacing.space_l};
  }
`;

export const Footer = styled.div`
  font-family: "Forma DJR UI", "HP Simplified", sans-serif;
  font-size: ${spacing.space_sm};
  font-weight: 400;
  line-height: ${spacing.space_l};
  padding-top: ${spacing.space_sm};

  && a {
    color: ${colors.interactiveLinkBase};
    text-decoration: underline;
  }

  @media screen and (max-width: ${breakpoints.mobile}) {
    font-size: 14px;
    line-height: ${spacing.space_m};
  }
`;

export const ToggleLayout = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  margin: 0 auto;

  .clientos-ui-toolkit-list-container .clientos-ui-toolkit-list-container__start-content {
    grid-gap: 0px;
    gap: 0px;
  }

  .clientos-ui-toolkit-list-container__label.body-large span[role="label"] {
    width: 100%;
    display: inline-block;
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    max-width: 100%;
  }
  @media screen and (min-width: 500px) and (max-width: 500px) and (min-height: 530px) and (max-height: 530px) {
    line-height: 1.25rem;
    font-size: 1rem;
  }
  > div:first-child > div > div {
  :nth-child(1) {
      > div:nth-child(1) {
        padding-bottom: 0px;
      }
        > div:nth-child(2) > div > div > div {
        padding-bottom: 12px;
        margin : 0px;
        > div > div {
          color: ${colors.inkSecondary};
        }
      }
    }  
  } 
  > div:nth-child(2) > div > div > div:nth-child(1) {
      padding-top: 12px;
      padding-bottom: 12px;
  }
  > div > div > div {
    > div:first-of-type {
      padding-left:0;
    }
  }
`;

export const StyledAccordion = styled(Accordion)`
  & > div {
    ${(props) => props.isWJA && 'border-color: transparent;'};
    & > div:first-of-type:focus {
      outline: none;
    }
  }
  & .css-hjbwtt {
    font-family: "Forma DJR UI", "HP Simplified", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    padding: 0 !important;
    border-color: transparent;
    margin: 0;
  }

  @media screen and (max-width: ${breakpoints.mobile}) {
      .css-hjbwtt {
        font-size: 14px;
        line-height: ${spacing.space_s};
      }
    }

  .css-1kn3elx, .css-1i17xdv {
  fill: ${colors.interactiveLinkBase}}

  .css-1ovr4cj {
    font-weight: 500;
  }

  .css-dul2cg,
  .css-1qxr67f,
  .css-1me4lo3 {
    padding: 24px 0;

    & a {
    color: ${colors.interactiveLinkBase};
  }

  .css-1x1n2cj {
    padding: 0 0 12px 0;
  }
`;

export const Graphic = styled.img`
  width: auto;
`;

export const ToggleLabelHeader = styled.label`
  font-size: 1rem;
  line-height: 1.25rem;
  margin-right: 0.5rem;
`;
export const ToggleLabelText = styled.div`
  display: inline;
`;

export const StyledButton = styled(Button)`
  @media screen and (min-width: 0\0) and (min-resolution: 0.001dpcm) {
    margin-left: 50%;
    transform: translate(-50%);
  }
  min-height: ${stylesIf('small', '2.25', '2.875')}rem;
  ${stylesIf('small', 'border-radius: 0.5rem;')}
  ${stylesIf(
    'hasBody',
    `
        @media screen and (min-width: 25.875rem) {
          margin-top: 1rem;
        }
      `
  )}
  @media screen and (min-width:500px) and (max-width:500px) and (min-height:530px ) and (max-height:530px) {
    padding-right: 1rem;
  }
`;

export const ConsentsButtonContainer = styled.div`
  display: flex; 
  width: 100%;
  flex-direction: row-reverse;
  padding: 0 24px;

  @media screen and (min-width: ${breakpoints.tablet}) {
    padding: 0 32px;
  }

  @media screen and (min-width: ${breakpoints.mobile}) {
    width: auto;
    justify-content: space-between;
  }

  & > button:first-of-type {
    margin-left: ${(props) => (props.isWJA ? '1.125rem' : '8px')};
  
  }


  @media screen and (max-width: ${breakpoints.mobile}) {
    gap: 8px;
    display: flex;
    padding-top: 1rem;
    flex-direction: column;
    width: auto;
    & > button:first-of-type {
      margin-left: 0;
    }
    & > button {
      width: auto;
    }
  }

  @media screen and (min-width: 500px) and (max-width: 500px) and (min-height: 530px) and (max-height: 530px) {
    flex-direction: row-reverse;
    justify-content: ${(props) => (props.isWJA ? '' : 'space-between')};
    width: 100%;
    align-items: center;
    padding-left: 2rem;
    padding-right: 2rem;
    padding-bottom: 0;
    box-sizing: border-box;
  
    & > button:first-of-type {
      margin-bottom: 0;
    }
  }
`;

export const ConsentsButtonLargeContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
`;

export const WjaContainer = styled.div`
  margin: auto;
`;

export const WjaToggleHeader = styled.div`
  display: flex;
  font-size: 0.975rem;
  font-weight: bold;
  margin-bottom: 10px;
`;

export const WjaToggleHeaderTitle = styled.p`
  margin: 5px 0 0 10px;
`;

export const WjaToggleBody = styled.div`
  margin-left: 35px;
`;

export const WjaToggleBodyExtens = styled.div`
  margin-top: 10px;
  font-size: 0.875rem;
  font-weight: bold;
`;

export const WjaToggleBodyExtensContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const WjaToggleBodyExtensContainerDesc = styled.p`
  text-align: left;
`;

export const WjaToggleBodyExtensContainerButton = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const WjaToggleBodyExtensContainerButtonText = styled.p`
  padding: 5px 0 0 10px;
`;

export const RebrandAccordionHeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const RebrandAccordionHeaderStart = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const RebrandToggleLabelHeader = styled.label`
  font-family: "Forma DJR UI", "HP Simplified", sans-serif;
  font-size: ${spacing.space_sm};  
  font-weight: bold;
  line-height: ${spacing.space_l};  

  && {
    @media screen and (max-width: ${breakpoints.mobile}) {
      line-height: ${spacing.space_m};
      font-size: 14px;
    }
 
`;
export const RebrandToggleLabelText = styled.div`
  display: inline;
  font-family: "Forma DJR UI", "HP Simplified", sans-serif;
  font-size: ${spacing.space_sm};  
  line-height: ${spacing.space_l};  

    && {
    @media screen and (max-width: ${breakpoints.mobile}) {
      line-height: ${spacing.space_m};
      font-size: 14px;
    }

    a {
      color: ${colors.interactiveLinkBase};
      text-decoration: underline;
    }
`;

export const RebrandCardContent = styled.div`
  max-width: 930px;
  max-height: 615px;
  overflow-y: auto;
  padding-right: 32px;

  scrollbar-width: thin;
  scrollbar-color: #aaa transparent;

  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #aaa;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  && {
    @media screen and (max-width: ${breakpoints.mobile}) {
      max-height: fit-content;
    }
  }

  #content-container .clientos-ui-toolkit-accordion:nth-child(1) > div > div:first-of-type > div > svg {
    display: none !important;
  }

  #content-container .clientos-ui-toolkit-accordion:nth-child(2) > div > div:first-of-type {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-top: 1px solid #d1d2e4;
  }
`;


export const RebrandBackGround = styled.div`
  direction: ${(props) => (props.isRTL ? 'rtl' : 'ltr')};
  text-align: ${(props) => (props.isRTL ? 'right' : 'left')};
  .clientos-ui-toolkit-device-list {
    min-height: 100vh;
  }

  @media screen and (max-width: ${breakpoints.mobile}) {
    .clientos-ui-toolkit-device-list__container {
      padding-top: ${spacing.space_sm};
    }
  } 

   @media screen and (width >= ${breakpointsRebrand['xs-min-width']}) and (width < ${
  breakpointsRebrand['xm-min-width']
}) {
  .clientos-ui-toolkit-device-list .clientos-ui-toolkit-device-list__container {
        margin: 0 48px;
    }
}

 @media screen and (width >= ${breakpointsRebrand['xm-min-width']}) and (width <= ${
  breakpointsRebrand['xm-max-width']
}) {
      .clientos-ui-toolkit-device-list .clientos-ui-toolkit-device-list__container {
        padding-top: 16px;
        width: 741px;
      }
  }

  @media screen and (width > ${breakpointsRebrand['xm-max-width']}) {
    .clientos-ui-toolkit-device-list .clientos-ui-toolkit-device-list__container {
        padding-top: 6px;
        width: 930px;
    }
  }
    
}

  & > :first-child {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .clientos-ui-toolkit-empty-card {
    position: relative;
    z-index: 1;
  }


  #settings-container {
    padding-right: 0;
    z-index: 1;
  }

  .css-hjbwtt {
    padding: 0 0 ${spacing.space_sm} 0 !important;
    margin: 0;
  }

  .css-1cduvgt {
    width: 100%;

    & > :nth-child(1) {
      width: 100%;

      & > :nth-child(1) {
        width: 100%;
      }
    }
  }
`;

export const RebrandFooterUserConsentsUpdate = styled.div`
  font-size: ${spacing.space_sm};
  line-height: ${spacing.space_m};
  font-family: "Forma DJR UI", "HP Simplified", sans-serif;
  text-align: left;

  & a {
    color: ${colors.interactiveLinkBase};
    text-decoration: underline;
  }
`;

export const RebrandEmptyPageWrapper = styled.div`
  @media screen and (max-width: ${breakpoints.tablet}) {
    .clientos-ui-toolkit-empty-page {
        .clientos-ui-toolkit-empty-page__content {
          padding-bottom: 142px;
          box-sizing: border-box;
          padding-right: 16px;
          padding-left: 16px;
          padding-top: 24px;
        }
      }
  }
`;

export const RebrandEmptyPageContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 742px;
  margin: auto;
  gap: ${spacing.space_l};

 .clientos-ui-toolkit-empty-card {
      margin-bottom: 1.5rem;
    @media screen and (min-width: ${breakpoints.tablet}) {
      margin-bottom: 2rem;
    }
  }
`;

export const RebrandUserConsentsTitle = styled(Title)`
    text-align: ${(props) => (props.isRTL ? 'right' : 'left')};
    @media(prefers-color-scheme: dark) {
      color:${colors.white};
    }
  && {
    @media screen and (max-width: ${breakpoints.mobile}) {
      font-size: 20px;
      line-height: 28px;
      text-align: ${(props) => (props.isRTL ? 'right' : 'left')};
    }
  }
`;

export const  RebrandUserConsentsCardContent = styled.div`
  direction: ${(props) => (props.isRTL ? 'rtl' : 'ltr')};
  text-align: ${(props) => (props.isRTL ? 'right' : 'left')};
  max-width: 930px;
  max-height: 615px;
  overflow-y: auto;
  overflow-x: hidden;

  && {
    @media screen and (max-width: ${breakpoints.mobile}) {
      max-height: fit-content;
    }
  }

  &&& {
    @media screen and (max-width: ${breakpoints.mobile}) {
      padding-top: 0;
      align-items: normal;
      .clientos-ui-toolkit-list-container > .clientos-ui-toolkit-list-container__item > .clientos-ui-toolkit-list-container__end-content .vn-toggle__span-text {
        display: none;
    }
  }

  &&&& {
    @media (max-width: ${breakpoints.mobile}) {
    .clientos-ui-toolkit-list-container>.clientos-ui-toolkit-list-container__item>div:not(:first-child) {
        margin-inline-start: 0px;
    }
}
  }
  

  .clientos-ui-toolkit-list-container__item {
    > .clientos-ui-toolkit-list-container__end-content.align-top {
      align-self: start;
    }
    &:last-child {
      padding-bottom: 0;
    }
  }
  
`;

export const RebrandUserConsentsBody = styled(Body)`
  direction: ${(props) => (props.isRTL ? 'rtl' : 'ltr')};
  text-align: ${(props) => (props.isRTL ? 'right' : 'left')};
  & {
    color: ${colors.inkSecondary}
  }
    
  && {
    @media(prefers-color-scheme: dark) {
        color: ${colors.white};
    }
    @media screen and (min-width: ${breakpoints.mobile}) {
      font-size: 14px;
      line-height: 20px;
    }
  }  
`

export const RebrandUserConsentsUpdateButtonContainer = styled.div`
  direction: ${(props) => (props.isRTL ? 'rtl' : 'ltr')};
  text-align: ${(props) => (props.isRTL ? 'right' : 'left')};
  display:flex;
  justify-content: flex-end;
  background: ${hexToRgba(colors.interfaceBackgroundPrimary, 0.7)};
  backdrop-filter: blur(4px);
  gap: ${(props) => (props.isRTL ? spacing.space_xs : spacing.space_none)};


  @media(prefers-color-scheme: dark) {
    background: ${colors.black};
  }

  @media screen and (max-width:${breakpoints.mobile}) {
    border-top: 1px solid ${colors.interfaceStrokeBase};
    width: calc(100% - 48px);
    position: fixed;
    bottom: 0;
    left: 0;
    flex-direction:column;
    padding: 24px;

    & > button {
      margin-left: 0;
      margin-right: 0;
      margin-bottom: 0.313rem;
      margin-top: 0.313rem;
      width: auto;
    }
    &>button:first-of-type {
      margin-top: 0;
      margin-bottom: ${(props)=> (props.isShowBackButton ? '0.313rem' : '0')};
    }
    &>button:last-of-type {
      margin-top: ${(props)=> (props.isShowBackButton ? '0.313rem' : '0')};  
      margin-bottom: 0;
    }
    @media(prefers-color-scheme: dark) {
        border-top-color: ${colors.inkSecondary};
    }
  }

  @media screen and (min-width: ${breakpoints.mobile}) {
    &>button:not(:first-of-type) {
      margin-right: ${(props)=> (props.isShowBackButton ? '0.5rem' : '0')};
    }
  }

`;

export const RebrandUserConsentsUpdateButtonLargeScreen = styled.div`
  display: flex;
  gap: .5rem;
`;

export const ListContainerRebrand = styled.p`
  padding-top: 0px;
  color: ${({ disabled }) => (disabled ? '#B5B7CB' : 'inherit')};
  @media screen and (max-width: ${breakpoints.mobile}) {
    font-size: 14px;
  }

  a {
    color: ${colors.interactiveLinkBase};
    text-decoration: underline;
  }
`

export const ListContainerContentToggleRebrand = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  clientos-ui-toolkit-list-container__label body-large
`

export const ListContainerTitleRebrand = styled.span`
  font-weight: 500;
  font-size: 16px;
  @media screen and (max-width: ${breakpoints.mobile}) {
    font-size: 14px;
  }
`

export const ButtonLoaderWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 24px;
  max-height: 24px;
  
  .clientos-ui-toolkit-loader {
    width: 24px !important;
    height: 24px !important;
    max-width: 24px;
    max-height: 24px;
  }
  
  svg {
    width: 24px !important;
    height: 24px !important;
    max-width: 24px;
    max-height: 24px;
  }
`
